import { useContext, useState } from "react";
import { T } from "../../constants/theme";
import { ToastContext } from "../../contexts/ToastContext";
import { apiFetch } from "../../services/api";

export default function NewsletterSection() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const toast = useContext(ToastContext);

  const submit = async () => {
    if (!email.includes("@")) return;

    const res = await apiFetch("/newsletter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (res.ok) {
      setDone(true);
      toast("Subscribed! Welcome to CropBank 🌱");
    }
  };

  return (
    <section
      style={{
        background: `linear-gradient(135deg, ${T.ink} 0%, ${T.inkSoft} 100%)`,
        padding: "72px 24px",
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 560, margin: "0 auto" }}>
        <p
          style={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: ".15em",
            textTransform: "uppercase",
            color: T.gold,
            margin: "0 0 12px",
          }}
        >
          Join The CropBank Community
        </p>

        <h2
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 36,
            color: T.white,
            margin: "0 0 14px",
          }}
        >
          New Projects, Funding Updates & Investor Insights
        </h2>

        <p
          style={{
            color: T.faint,
            fontSize: 16,
            margin: "0 0 36px",
            lineHeight: 1.7,
          }}
        >
          Sign up to hear about new farm and crop projects, funding
          milestones, and IoT-backed performance updates delivered
          straight to your inbox.
        </p>

        {done ? (
          <p
            style={{
              color: T.gold,
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            ✓ You're on the list!
          </p>
        ) : (
          <div
            style={{
              display: "flex",
              gap: 0,
              maxWidth: 440,
              margin: "0 auto",
            }}
          >
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && submit()}
              placeholder="Your email address"
              style={{
                flex: 1,
                padding: "14px 18px",
                borderRadius: "12px 0 0 12px",
                border: "none",
                fontSize: 15,
                outline: "none",
                background: "rgba(255,255,255,.15)",
                color: T.white,
              }}
            />

            <button
              onClick={submit}
              style={{
                background: T.gold,
                color: T.white,
                border: "none",
                padding: "14px 24px",
                borderRadius: "0 12px 12px 0",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              Subscribe →
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
